module.exports = __webpack_public_path__ + "img/css-logo.c26a73b4.png";